import { Meta } from './seo/Meta';

export function PrivacyPage() {
  return (
    <div className="landing-root min-h-screen bg-l-paper text-l-ink font-sans">
      <Meta
        title="Политика обработки персональных данных · matemasha.ru"
        description="Политика обработки персональных данных при заполнении формы на matemasha.ru"
      />
      <main className="px-6 md:px-10 py-16 md:py-24">
        <div className="mx-auto max-w-[720px]">
          <h1 className="font-display font-medium text-l-ink-deep text-[32px] md:text-[40px] leading-[1.15] tracking-[-0.02em] mb-8">
            Политика обработки персональных данных
          </h1>
          <div className="prose prose-lg max-w-none font-sans text-l-ink text-[16px] leading-[1.6] space-y-5">
            <p>
              Настоящая политика действует в отношении персональных данных, которые
              оператор (Мария Брызгалова, г. Екатеринбург) может получить от посетителей
              сайта matemasha.ru.
            </p>
            <h2 className="font-display text-l-ink-deep text-2xl mt-8 mb-3">
              Какие данные собираются
            </h2>
            <p>
              Имя, контакт (телефон, Telegram или email) и класс ученика — вы передаёте
              их самостоятельно через форму записи. Дополнительно фиксируются IP-адрес
              и User-Agent браузера для защиты от спам-запросов.
            </p>
            <h2 className="font-display text-l-ink-deep text-2xl mt-8 mb-3">
              Цели обработки
            </h2>
            <p>
              Связаться с вами для согласования пробного занятия. Данные не передаются
              третьим лицам, не используются для рассылок и не продаются.
            </p>
            <h2 className="font-display text-l-ink-deep text-2xl mt-8 mb-3">
              Сроки хранения
            </h2>
            <p>
              Заявки хранятся до 12 месяцев с момента получения. По вашему запросу
              данные удаляются в течение 7 рабочих дней.
            </p>
            <h2 className="font-display text-l-ink-deep text-2xl mt-8 mb-3">
              Ваши права
            </h2>
            <p>
              Вы можете запросить удаление или изменение ваших данных, написав на{' '}
              <a href="mailto:hello@matemasha.ru" className="text-l-terracotta underline">
                hello@matemasha.ru
              </a>
              .
            </p>
            <p className="text-l-ink-muted text-sm mt-10">
              Действует с 2026 года. Последнее обновление: {new Date().toLocaleDateString('ru-RU')}.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
